/**
 * @description 把 promise 异常和数据返回成数组类型
 * @param {Promise} promise 任何类型的 Promise
 */
export function to(promise: Promise<any>) {
  return promise
    .then((data: any) => [null, data.data])
    .catch((err: any) => [err]);
}
/**
 * 验证身份证号
 */

export function checkIdCard(idCard: string) {
  const regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
  if (regIdCard.test(idCard)) {
    if (idCard.length === 15) {
      return checkBirthday(idCard) && checkProvince(idCard.substr(0, 2));
    } else {
      return (
        checkCode(idCard) &&
        checkBirthday(idCard) &&
        checkProvince(idCard.substr(0, 2))
      );
    }
  }

  return (
    regIdCard.test(idCard) &&
    checkCode(idCard) &&
    checkBirthday(idCard) &&
    checkProvince(idCard.substr(0, 2))
  );
  // 检查身份证所在省
  function checkProvince(val: string) {
    const pattern = /^[1-9][0-9]/;
    const province = [
      11,
      12,
      13,
      14,
      15,
      21,
      22,
      23,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      41,
      42,
      43,
      44,
      45,
      46,
      50,
      51,
      52,
      53,
      54,
      61,
      62,
      63,
      64,
      65,
      71,
      81,
      82
    ];
    if (pattern.test(val)) {
      if (~province.indexOf(+val)) {
        return true;
      }
    }
    return false;
  }
  // 检查身份证的生日
  function checkBirthday(val: string) {
    let birthday = "";
    if (val.length === 15) {
      birthday = val.substring(6, 12);
    } else {
      birthday = val.substring(6, 14);
    }
    const year =
      birthday.length === 6
        ? 1900 + parseInt(birthday.substr(0, 2))
        : birthday.substr(0, 4);
    const month =
      birthday.length === 6 ? birthday.substr(2, 2) : birthday.substr(4, 2);
    const day =
      birthday.length === 6 ? birthday.substr(4, 2) : birthday.substr(6, 2);
    console.log(year, month, day);
    const date = new Date(year + "-" + month + "-" + day);
    if (date && date.getMonth() == parseInt(month) - 1) {
      return true;
    }
    return false;
  }
  // 检查校验码
  function checkCode(val: any) {
    const idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; //将前17位加权因子保存在数组里
    const idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; //这是除以11后，可能产生的11位余数、验证码，也保存成数组
    let idCardWiSum: any = 0; //用来保存前17位各自乖以加权因子后的总和
    for (let i: any = 0; i < 17; i++) {
      idCardWiSum += val.substring(i, i + 1) * idCardWi[i];
    }
    const idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
    const idCardLast = val.substring(17); //得到最后一位身份证号码
    // 如果等于2,则说明校验码是10,身份证号码最后一位是 X
    if (idCardMod === 2) {
      return idCardLast.toUpperCase() === "X";
    } else {
      // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
      return +idCardLast === idCardY[idCardMod];
    }
  }
}
